import { Category } from "../models/Category";
import { getApi } from "./Api";


export const getAllCategories = async () => {
    try{
        return await getApi<Category[]>('categories')
    }
    catch(error){
        throw error;
    }
}